import React, { useMemo, useState } from "react";
import { Form, Input, Button, Card, Space, Divider, message } from "antd";
import { postRequest } from "../api/api";
import {  MdOutlineNotificationsActive  } from "react-icons/md";

const { TextArea } = Input;

const Notification = () => {
  const [form] = Form.useForm();
  const [sending, setSending] = useState(false);

  // Live preview of the payload
  const values = Form.useWatch([], form);
  const payload = useMemo(() => {
    const v = values || {};
    return {
      title: v?.title || "",
      body: v?.body || "",
      data: {
        type:"creative",
      //   title: v?.data?.title || "",
      //   image: v?.data?.image || "",
      //   description: v?.data?.description || "",
      },
    };
  }, [values]);

  const onFinish = async () => {
    try {
      setSending(true);
      // POST exactly this shape to /notify/all-users
      await postRequest("notify/all-users", payload);
      message.success("Notification sent to all users 🎉");
      form.resetFields();
    } catch (e) {
      console.error(e);
      message.error(
        e?.response?.data?.message || "Failed to send notification"
      );
    } finally {
      setSending(false);
    }
  };



  return (
    <>
      <h2 style={{ marginLeft:20, color: "#5a355a" }}> <MdOutlineNotificationsActive/>  Send Push Notification</h2>
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <Space
          align="center"
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 12,
          }}
        >
          {/* <h2 style={{ margin: 0, color: "#5a355a" }}>Send Push Notification</h2> */}
          {/* <Space>
      <Button onClick={fillTemplate}>Use Example</Button>
      <Button onClick={() => form.resetFields()}>Reset</Button>
      <Button type="primary" loading={sending} onClick={() => form.submit()}>
        Send to All Users
      </Button>
    </Space> */}
        </Space>

        <Card>
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            initialValues={{
              data: { type: "", title: "", image: "", description: "" },
            }}
          >
            {/* <Divider orientation="left">Notification</Divider> */}

            <Form.Item
              label="Title"
              name="title"
              rules={[{ required: true, message: "Title is required" }]}
            >
              <Input
                showCount
                maxLength={120}
                placeholder="e.g., 💪 Ready to Strengthen Your Journey?"
              />
            </Form.Item>

            <Form.Item
              label="Body"
              name="body"
              rules={[{ required: true, message: "Body is required" }]}
            >
              <TextArea
                showCount
                maxLength={250}
                rows={3}
                placeholder="e.g., Fill out your profile to receive custom therapy guidance and better recovery support."
              />
            </Form.Item>

            {/* <Form.Item
              label="Type"
              name={["data", "type"]}
            //   rules={[{ required: true, message: "Type is required" }]}
            >
              <Input placeholder='e.g., "profile" (your app will route based on this)' />
            </Form.Item> */}

            {/* <Form.Item label=" Title" name={["data", "title"]}>
              <Input
                showCount
                maxLength={120}
                placeholder="e.g., Complete Your Profile 💥"
              />
            </Form.Item>

            <Form.Item label="Image URL" name={["data", "image"]}>
              <Input placeholder="https://..." />
            </Form.Item>

            <Form.Item label="Description" name={["data", "description"]}>
              <TextArea
                showCount
                maxLength={500}
                rows={4}
                placeholder="Short description shown in app after open"
              />
            </Form.Item> */}

            <Divider />

            <Space style={{ width: "100%", justifyContent: "flex-end" }}>
              <Button onClick={() => form.resetFields()}>Reset</Button>
              <Button type="primary" htmlType="submit" loading={sending}>
                Send to All Users
              </Button>
            </Space>
          </Form>
        </Card>
      </div>
    </>
  );
};

export default Notification;
